import React from "react";
import { withStyles } from '@material-ui/core';
import { styles } from "./style";
import SummaryView from "components/SuccessAnalysis/components/SummaryView";
import Loader from 'storybookComponents/Loader';
import { createDateRange } from "content/utils/commonParsing"
import { getAttendeesOverview } from "relay/event"
// Colors for each status
const colors = {
  firstColumn: '#9AEBFD',
  secondColumn: '#9AD3FD',
  thirdColumn: '#9AB6FD',
  fourthColumn: "#EEEEEE",
  // notAchieved: '#F1A066'
}

const labels = {
  "label1": "Prospects",
  "label2": "Residents",
  "label3": "Brokers",
  label4: "No attendees",
}


const StatsDetails = ({ classes, count, type }) => {
  return (
    <div className={classes.cardContainer}>
      <div className={classes.countSize} >{count}</div>
      <div className={classes.typeStyle}>{type} </div>
    </div>
  )
}


const Overview = ({ classes, monthRange, subOrgDetails, orgLevel }) => {
  const [summaryData, setSummaryData] = React.useState(null)
  const [propertiesNumber, setPropertiesNumber] = React.useState(null)
  const [loading, setLoading] = React.useState(true);
  const [topChart, setTopChart] = React.useState();


  React.useEffect(() => {
    getOverviewStats(monthRange);
  }, [monthRange])


  const getOverviewStats = async (date) => {
    try {
      setLoading(true)
      let response = await getAttendeesOverview(subOrgDetails.org.id, orgLevel ? null : subOrgDetails.id, date.startAt, date.endAt);
      if (response.attendeesOverview) {
        setTopChart(response.attendeesOverview);
        let obj = {
          firstColumn: response.attendeesOverview.prospectsCount || 0,
          secondColumn: response.attendeesOverview.residentsCount || 0,
          thirdColumn: response.attendeesOverview.brokersCount || 0,
        }
        setSummaryData(obj)
        setPropertiesNumber((obj.firstColumn + obj.secondColumn + obj.thirdColumn))
        setLoading(false)
      }
    } catch (err) {
      console.log("Error :", err);
    }
  }

  if (loading) {
    return <Loader />
  }
  return (
    <div className={classes.root}>
      <div className={classes.topContainer}>
        <StatsDetails classes={classes} count={topChart.propertiesCount} type="Properties" />
        <StatsDetails classes={classes} count={topChart.hyeventsCount} type="Events" />
        <StatsDetails classes={classes} count={topChart.rsvpsCount} type="RSVPed" />
        <StatsDetails classes={classes} count={topChart.attendedCount} type="Attended" />
        <StatsDetails classes={classes} count={topChart.notAttendedCount} type="Not Attended" />
      </div>
      <div className={classes.attendees}>Attendees</div>
      <SummaryView labels={labels} colors={colors} data={summaryData} propertiesNumber={propertiesNumber} />
    </div>)
}

export default withStyles(styles)(Overview)